import React from 'react';
import { useCss } from 'react-use';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';

import logger from '../../../utils/logger.util';

import CN from './CategoryItem.module.scss';

const L = logger('CategoryItem');

const CategoryItem = ({ categoryName, color: backgroundColor, onAddServiceCategory }) => {
  const { isDarkMode } = useTheme();

  const handleClick = L.wrap('handleClick()', onAddServiceCategory);

  const buletBackground = useCss({ backgroundColor });

  return (
    <div
      data-bem="CategoryItem"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.serviceItem} role="button" tabIndex={0} onClick={handleClick}>
        <div className={CN.backgroundColor} />
        <span className={cn(CN.buletColor, buletBackground)} />
        <div data-bem="CategoryItem__name" className={CN.name}>
          {categoryName}
        </div>
      </div>
    </div>
  );
};

export default CategoryItem;
